import { render, staticRenderFns } from "./PartsEditTable.vue?vue&type=template&id=52fee09b&"
import script from "./PartsEditTable.vue?vue&type=script&lang=ts&"
export * from "./PartsEditTable.vue?vue&type=script&lang=ts&"
import style0 from "./PartsEditTable.vue?vue&type=style&index=0&id=52fee09b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports